import React, { createContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BaseModal from '../BaseModal';
import { styles as modalStyles } from '../Styles';
import styles from './ReportAccordance.module.scss';
import Select from 'react-select';
import SaveButton from '../../Buttons/SaveButton/SaveButton';
import { DropdownIndicator, reportAccordanceStyle } from '../../../Filter/FilterComponent.Styles';
import { useFrontEndBasedSelectedsOptions } from '../../../../hooks/useFrontEndBasedSelectedsOptions';
import UndoButton from '../../Buttons/UndoButton/UndoButton';
import { GetSectionReportEnum } from '../../../../models/ReportEnums';
import { IAccordanceReportParams } from '../../../../models/AccordanceReportParams';
import { yearsListOptions } from './Util';
import { UserBasedOptions } from './UserBasedOptions/UserBasedOptions';
import { handleUpdateItemsIds } from './UserBasedOptions/Util';
import { getProjectReport } from '../../../../api/projectApi';
import SpinningLoader from '../../../ProjectDetail/ProjectTabs/Loader/SpinningLoader';
import AutoDismissAlert from '../../../Projects/ProjectsReport/view/Common/AlertTooltips';
import { ERROR_IN_GENERATE_REPORT, SUCESSFUL_GENERATED_AGREEMENT_REPORT } from '../../../Projects/ProjectsReport/utils/Constants/AlertStatusConstants';
import { ReactComponent as CloseIcon } from '../../../../assets/icons/u_multiply.svg';

const DEFAULT_AGREEMENT_REPORT_FILENAME = 'agreement_report.xlsx';

const {
  label,
  downloadingReport,
  modalReportContent,
  titleAndCloseForm,
  formLeftPanelContent,
  inputsLeftPanel,
  subTitleLeftPanel,
  lineDivision,
  butonsFormContent
} = styles;

type Props = {
  isOpen: boolean;
  closeModal: any;
  submit: any;
};

export interface IprojectReport {
  base64: string;
  contentType: string;
  filename: string;
}

const reportAccordanceParams: IAccordanceReportParams = {
  reportType: GetSectionReportEnum.Accordances_New,
  accordanceTypes: [],
  accordanceState: [],
  accordanceYears: [],
  country: [],
  region: [],
  sector: [],
  division: [],
};

const handleDownloadProjectReport = async (payload: IAccordanceReportParams) => {
  try {
    const response = await getProjectReport(payload);
    const downloadUrl = window.URL.createObjectURL(response.blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = response.filename || DEFAULT_AGREEMENT_REPORT_FILENAME;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const ReportAccordanceContext = createContext([{}, () => { }]);
export const ReportAccordance = ({ isOpen, closeModal, submit }: Props) => {
  const SHOW_YEARS_FROM = 2020;
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();
  const reportOfAgreements = t('report_of_agreements');
  const { acordanceTypeOptions, acordancStateOptions } = useFrontEndBasedSelectedsOptions();
  const yearListOptions = yearsListOptions(SHOW_YEARS_FROM, currentYear);
  const [selectedAccordanceType, setSelectedAccordanceType] = useState<any>([]);
  const [selectedAccordanceState, setSelectedAccordanceState] = useState<any>([]);
  const [selectedAccordanceYears, setSelectedAccordanceYears] = useState<any>([
    yearListOptions.find(option => option.id === currentYear),
  ]);
  const [selectedParamsToEndPoint, setSelectedParamsToEndPoint] = useState(reportAccordanceParams);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [alertConfig, setAlertConfig] = useState<any>();


  useEffect(() => {
    setSelectedParamsToEndPoint(prev => ({
      ...prev,
      accordanceTypes: handleUpdateItemsIds(selectedAccordanceType),
      accordanceState: handleUpdateItemsIds(selectedAccordanceState),
      accordanceYears: handleUpdateItemsIds(selectedAccordanceYears),
    }));
  }, [selectedAccordanceType, selectedAccordanceState, selectedAccordanceYears]);

  const handleSubmit = async () => {
    setIsLoading(true);
    const payload = await submit(selectedParamsToEndPoint);
    try {
      await handleDownloadProjectReport(payload);
      setAlertConfig(SUCESSFUL_GENERATED_AGREEMENT_REPORT);
    } catch (error) {
      console.error('Error downloading the report:', error);
      setAlertConfig(ERROR_IN_GENERATE_REPORT);
    }
    finally {
      setIsLoading(false);

      setTimeout(() => {
        closeModal();
      }, 3000);
    }
  };

  const handleCloseModal = () => {
    closeModal();
  };


  return (
    <>
      <BaseModal
        isOpen={isOpen && !alertConfig}
        onRequestClose={e => { }}
        className={modalReportContent}
        style={{ overlay: { ...modalStyles.overlay, ...{ overflowY: 'auto' } } }}
      >
        <div>
          <ReportAccordanceContext.Provider value={[selectedParamsToEndPoint, setSelectedParamsToEndPoint]}>
            <div className={titleAndCloseForm}>
              <p>{reportOfAgreements.charAt(0).toUpperCase() + reportOfAgreements.slice(1)} </p>
              <CloseIcon style={{ cursor: 'pointer' }} onClick={handleCloseModal} />
            </div>

            <div className={formLeftPanelContent}>
              <div className={inputsLeftPanel}>
                <p className={subTitleLeftPanel}>{t('general_info')}</p> {/* Agregar a Traducciones */}

                <div>
                  <p className={label}>{t('type_of_accordance')}</p>
                  <Select
                    id="accordanceType"
                    components={{ DropdownIndicator }}
                    value={selectedAccordanceType}
                    options={acordanceTypeOptions}
                    className="basic-multi-select"
                    classNamePrefix="All"
                    placeholder={t('all')}
                    onChange={value => setSelectedAccordanceType(value)}
                    styles={reportAccordanceStyle}
                    isMulti
                  />
                </div>

                <div >
                  <p className={label}>{t('accordance_status')}</p>
                  <Select
                    id="accordanceState"
                    components={{ DropdownIndicator }}
                    value={selectedAccordanceState}
                    options={acordancStateOptions}
                    className="basic-multi-select"
                    classNamePrefix="All"
                    placeholder={t('all')}
                    onChange={value => setSelectedAccordanceState(value)}
                    styles={reportAccordanceStyle}
                    isMulti
                  />
                </div>

                <div >
                  <p className={label}>{t('year_of_creation_of_the_agreement')}</p>
                  <Select
                    id="yearOfCreation"
                    components={{ DropdownIndicator }}
                    value={selectedAccordanceYears}
                    options={yearListOptions}
                    className="basic-multi-select"
                    classNamePrefix="All"
                    placeholder={t('all')}
                    onChange={value => setSelectedAccordanceYears(value)}
                    styles={reportAccordanceStyle}
                    maxMenuHeight={150}
                    isMulti
                  />
                </div>
              </div>

              <div className={lineDivision} />

              <UserBasedOptions />
            </div>

            <div className={butonsFormContent}>
              <UndoButton handleClick={handleCloseModal} customText={t('close')} customStyle={{ marginLeft: 16 }} />
              <SaveButton
                handleClick={() => handleSubmit()}
                customText={t('create_report')}
              />
            </div>
          </ReportAccordanceContext.Provider>
        </div>
      </BaseModal>
      <BaseModal
        isOpen={isLoading}
        style={modalStyles}
        className={downloadingReport}
      >
        <SpinningLoader customStyle={{ marginTop: 0 }} customText={t('one_pager_report.downloading_agreement_report')} />
      </BaseModal>
      {alertConfig && (
        <AutoDismissAlert
          message={alertConfig.message}
          title={alertConfig.title}
          severity={alertConfig.severity}
          duration={alertConfig.duration}
          onClose={() => setAlertConfig(null)}
        />
      )}
    </>
  );
};
